export const BLOCK_TYPE_PERMANENT = 'PERMANENT';

export const BLOCK_TYPE_OLD_NPI = 'OLD_NPI';

export const BLOCK_TYPES = [BLOCK_TYPE_PERMANENT, BLOCK_TYPE_OLD_NPI] as const;

export type SharedPatientAssistancePharmacyEnrollmentGroupBlockTypeType = (typeof BLOCK_TYPES)[number];
